// Convierte una hora 24H ("14:30") a formato 12H ("2:30 PM").
export const formatearHora12 = (h24) => {
  if (!h24) return '';
  const [h, m] = h24.split(':').map(Number);
  let periodo = 'AM';
  let hh = h;
  if (h === 0) hh = 12;
  else if (h === 12) periodo = 'PM';
  else if (h > 12) {
    hh = h - 12;
    periodo = 'PM';
  }
  return `${hh}:${m.toString().padStart(2, '0')} ${periodo}`;
};

// Margen histórico fijo. Solo se usa como fallback: hoy el backend calcula la
// ventana adaptándola a la duración del bloque (un bloque de 15 min no puede
// cerrar 15 min antes de su fin) y la envía en VentanaInicio / VentanaFin.
const MARGEN_FALLBACK_MIN = 15;

// Resta minutos a una hora "HH:MM" sin salirse del día.
const restarMinutos = (h24, minutos) => {
  if (!h24) return '';
  const [h, m] = h24.split(':').map(Number);
  const total = Math.max(0, h * 60 + m - minutos);
  const hh = Math.floor(total / 60);
  return `${hh.toString().padStart(2, '0')}:${(total % 60).toString().padStart(2, '0')}`;
};

// Ventana en la que el docente puede marcar asistencia de un horario, como
// strings "HH:MM". La fuente de verdad es el backend; el fallback cubre
// respuestas de versiones anteriores que aún no traen los campos.
export const getVentanaMarcado = (horario) => ({
  inicio: horario?.VentanaInicio || restarMinutos(horario?.HoraInicio, MARGEN_FALLBACK_MIN),
  fin: horario?.VentanaFin || restarMinutos(horario?.HoraFin, MARGEN_FALLBACK_MIN),
});
